import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import HomePage from './pages/HomePage';
import LocalesPage from './pages/LocalesPage';
import LocalDetailPage from './pages/LocalDetailPage';
import EventosPage from './pages/EventosPage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminBanners from './pages/admin/AdminBanners';
import AdminLocales from './pages/admin/AdminLocales';
import AdminEventos from './pages/admin/AdminEventos';
import AdminLogin from './pages/admin/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App min-h-screen">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/locales" element={<LocalesPage />} />
          <Route path="/local/:slug" element={<LocalDetailPage />} />
          <Route path="/eventos" element={<EventosPage />} />
          
          {/* Admin Routes */}
          <Route path="/admincclc/login" element={<AdminLogin />} />
          <Route
            path="/admincclc"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/admincclc/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="banners" element={<AdminBanners />} />
            <Route path="locales" element={<AdminLocales />} />
            <Route path="eventos" element={<AdminEventos />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        
        {/* WhatsApp Floating Button */}
        <WhatsAppButton />
        
        {/* Toast Notifications */}
        <Toaster position="top-right" richColors />
      </div>
    </Router>
  );
}

export default App;